// extracted by mini-css-extract-plugin
export var numberInputContainer = "_83-0";
export var startPickingButton = "_83-1";